import React from "react";
import styled from "styled-components";
import DarkGrayArrowRight from "@src/assets/basicIcon/darkGrayArrowRight.svg";
import { NewChattingRoomItem } from "@src/hooks/auctionAgent/chat";
import { transferToNative } from "@src/lib/WebAppBridge";

const MatchItemPreview = ({ item }: { item: NewChattingRoomItem }) => {
    return (
        <MatchItemPreviewBox
            onClick={() => {
                transferToNative(JSON.stringify({ itemId: item.itemId, bidType: item.bidType }), "openBidDetail");
            }}
        >
            <img className="item-image" src={item.itemImage} alt="matchItemPreview" width={44} height={44} />
            <div className="item-info-box">
                <div className="item-info">
                    <div className="item-info-title">
                        <span className="type">경매</span>
                        <span>{item.itemSubId}</span>
                    </div>
                    <div className="item-info-detail">
                        {item.itemUseDetail}・{item.itemAddress}
                    </div>
                </div>
                <img className="item-info-arrow" src={DarkGrayArrowRight} alt="matchItemPreview" width={24} height={24} />
            </div>
        </MatchItemPreviewBox>
    );
};

export default MatchItemPreview;

const MatchItemPreviewBox = styled.div`
    width: 100%;
    height: 100%;
    gap: 12px;
    display: flex;
    align-items: center;

    .item-image {
        object-fit: cover;
        border-radius: 6px;
    }

    .item-info-box {
        width: 100%;

        display: flex;
        align-items: start;
        justify-content: space-between;
    }

    .item-info {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .item-info-title {
        display: flex;
        gap: 4px;
        font-size: 16px;
        font-weight: 700;
        color: #282828;
        align-items: center;

        .type {
            font-size: 12px;
            color: white;
            background-color: #000000;
            padding: 4px 8px;
            border-radius: 4px;
            background-color: #2275ee;
            font-weight: 400;
        }
    }

    .item-info-detail {
        font-size: 12px;
        color: #505050;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 220px;
        display: block;
    }
`;
